module.exports = __webpack_public_path__ + "img/icon_camera.bd9a622a.svg";